module.exports = __webpack_public_path__ + "img/sampleImage.3a64d992.jpg";